import { render, staticRenderFns } from "./raffle_config_form.vue?vue&type=template&id=58006d84&scoped=true"
import script from "./raffle_config_form.vue?vue&type=script&lang=js"
export * from "./raffle_config_form.vue?vue&type=script&lang=js"
import style0 from "./raffle_config_form.vue?vue&type=style&index=0&id=58006d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58006d84",
  null
  
)

export default component.exports